import { paletteBase } from '@abg/kit-base';

import { SubmitMfaFormBodyStyling } from './types';

export const submitMfaFormBodyStyling: SubmitMfaFormBodyStyling = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: '20px', sm: '20px' },
  },
  chosenMethodDescription: {
    color: paletteBase.secondary400,
  },
  entryWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  entryOtherActions: {
    wrapper: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    otherOptionsText: {
      height: '20px',
      color: paletteBase.secondary400,
    },
  },
};
